export const userTypes = {
  MEMBER: 'member',
}

export default userTypes
